import { __awaiter } from "tslib";
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import SERVICES from '@/constants/services';
import { LevelName } from './types';
import { getPassportUrl } from '@/utils/other';
export default Vue.extend({
    name: 'commonConfirmSMSPopupChunk',
    props: {
        slotData: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        form: {
            fields: {
                smsCode: {
                    sending: false,
                    valid: false,
                    codeIsSent: false,
                    codeSentBefore: false,
                    retryTimeout: 60,
                    retries: 3,
                    letRetry: false,
                    value: '',
                    rules: [
                        (v) => Boolean(v) || 'Поле обязательно',
                        (v) => v.length === SERVICES.CODE_LENGTH || `Код должен состоять из ${SERVICES.CODE_LENGTH} символов`
                    ]
                }
            }
        }
    }),
    computed: Object.assign({}, mapGetters('user', ['getUserData'])),
    watch: {
        'form.fields.smsCode.retryTimeout'(v) {
            const vm = this;
            if (v > 0) {
                setTimeout(() => {
                    vm.form.fields.smsCode.retryTimeout = v - 1;
                }, 1000);
            }
            else
                vm.form.fields.smsCode.letRetry = true;
        },
        'form.fields.smsCode.valid'(v) {
            if (v && this.form.fields.smsCode.value.length > 0) {
                this.$store.commit('popupModule/setSlotData', { isLoading: true });
                setTimeout(() => {
                    this.$emit('onSubmit', { code_sms: this.form.fields.smsCode.value });
                }, 1000);
            }
        },
        'form.fields.smsCode.value'() {
            this.$store.commit('popupModule/setSlotData', { responseErrors: [] });
        }
    },
    created() {
        this.sendSMS();
    },
    methods: {
        hasntAccessHandler() {
            const hasCurrentMethod = this.getUserData.currentAccessRepairMethods.includes('sms');
            const vm = this;
            if (hasCurrentMethod) {
                this.$store.dispatch('popupModule/openPopup', {
                    type: 'confirmPopup',
                    letDefaultClose: true,
                    title: 'Предупреждение',
                    content: 'В данный момент идет восстановление телефона, установленного как метод 2FA для подтверждения операций в Личном кабинете. Вы сможете выполнить операцию после завершения восстановления.',
                    actions: [
                        {
                            title: 'Хорошо',
                            isAccent: true,
                            callback() { vm.$store.commit('popupModule/setClosed'); }
                        }
                    ]
                });
                return;
            }
            const isBasic = this.getUserData.verificationRights.levelName === LevelName.basic;
            if (isBasic) {
                vm.$store.dispatch('popupModule/openPopup', {
                    type: 'confirmPopup',
                    letDefaultClose: false,
                    title: 'Восстановление телефона',
                    content: 'Чтобы восстановить телефон, нужно пройти расширенную верификацию аккаунта.',
                    actions: [
                        {
                            title: 'К разделу',
                            isAccent: true,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                                window.location.href = getPassportUrl('/id/', { withAcceptor: true });
                            }
                        },
                        {
                            title: 'Позже',
                            isAccent: false,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                            }
                        }
                    ]
                });
                return;
            }
            this.$router.push({ name: 'AccessRepair', query: { secondFactor: 'sms', an3K8QkkJb3Mzz: this.slotData.sessionId } });
        },
        sendSMS() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.form.fields.smsCode.codeSentBefore = false;
                vm.form.fields.smsCode.sending = true;
                const response = yield vm.services.mainService.sendCode(vm.slotData.codes.sms.type);
                vm.form.fields.smsCode.sending = false;
                if (response.success) {
                    vm.form.fields.smsCode.codeIsSent = true;
                    vm.form.fields.smsCode.letRetry = false;
                    vm.form.fields.smsCode.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                    vm.form.fields.smsCode.retries -= 1;
                    setTimeout(() => {
                        vm.form.fields.smsCode.retryTimeout -= 1;
                    }, 1000);
                }
                else {
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.repeatAfter) {
                        vm.form.fields.smsCode.codeSentBefore = true;
                        vm.form.fields.smsCode.codeIsSent = true;
                        vm.form.fields.smsCode.letRetry = false;
                        vm.form.fields.smsCode.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                        vm.form.fields.smsCode.retries -= 1;
                        setTimeout(() => {
                            vm.form.fields.smsCode.retryTimeout -= 1;
                        }, 1000);
                    }
                    else {
                        vm.form.fields.smsCode.codeSendError = true;
                        vm.form.fields.smsCode.letRetry = true;
                    }
                }
            });
        }
    }
});
